'use client'

import { useEffect } from 'react'
import { sendGTMEvent } from '@next/third-parties/google'
import type { TreatmentType } from '@/lib/apis/treatments'
import { treatmentQuizMidEvent } from './treatment-quiz-mid-event'

export default function TreatmentQuizMidEventSender({
  storyId,
  type,
}: {
  storyId: string
  type: TreatmentType
}) {
  useEffect(() => {
    const event = treatmentQuizMidEvent(type, storyId)
    if (!event) return
    try {
      sendGTMEvent(event)
    } catch {
      // A tracking failure must not interrupt treatment questions.
    }
  }, [storyId, type])

  return null
}
